import MobileDetect from 'mobile-detect';
import { Storage } from './storage';

/**
 * 设备相关工具函数
 */

/**
 * 判断是否为移动端设备
 * 复用与路由相同的 mobile-detect 逻辑，供全局使用
 */
export function isMobile(): boolean {
  if (typeof window === 'undefined' || !window.navigator?.userAgent) {
    return false;
  }
  const md = new MobileDetect(window.navigator.userAgent);
  return md.mobile() !== null;
}

/**
 * 生成唯一设备ID
 * 如果本地存储中已存在，则返回已存储的ID，否则生成新的ID并存储
 */
export function generateDeviceId(): string {
  const DEVICE_ID_KEY = 'device_id';

  // 先从本地存储获取
  const existingDeviceId = Storage.getItem<string>(DEVICE_ID_KEY);
  if (existingDeviceId) {
    return existingDeviceId;
  }

  // 生成新的设备ID
  const timestamp = Date.now().toString(36);
  const randomPart = Math.random().toString(36).substring(2, 15);
  const deviceId = `${timestamp}_${randomPart}`;

  // 存储到本地
  Storage.setItem(DEVICE_ID_KEY, deviceId);

  return deviceId;
}

import type { AppPlatform } from '../services/websocket/BDSocketManager';

/**
 * 获取应用平台类型
 * 根据运行环境判断平台
 */
export function getAppPlatform(): AppPlatform {
  // 检查是否在 Electron 环境中
  if (typeof window !== 'undefined' && window.process) {
    switch (window.process.platform) {
      case 'linux':
        return 'pc';
      case 'darwin':
        return 'mac';
      case 'win32':
        return 'pc';
      default:
        return 'pc';
    }
  }

  // 检查是否在移动设备上
  if (typeof window !== 'undefined' && window.navigator) {
    const userAgent = window.navigator.userAgent.toLowerCase();

    if (/android/.test(userAgent)) {
      return 'android';
    }

    if (/iphone|ipad|ipod/.test(userAgent)) {
      return 'ios';
    }
  }

  // 默认返回 web 平台
  return 'web';
}

/**
 * 获取产品名称
 * 可以根据环境变量或配置文件来确定产品名称
 */
export function getProductName(): string {
  // 这里可以根据实际项目需求配置产品名称
  // 可以从环境变量中读取，或者从配置文件中获取
  // return process.env.VITE_PRODUCT_NAME || 'leadsnavi';
  return 'leadsnavi';
}

/**
 * 获取应用版本
 */
export function getAppVersion(): string {
  // 可以从package.json中读取版本号，或者从环境变量中获取
  return process.env.VITE_APP_VERSION || '0.0.1';
}

/**
 * 检查是否为测试环境
 */
export function isTestEnvironment(): boolean {
  return process.env.NODE_ENV !== 'production';
}

/**
 * 扩展Window接口以支持process属性
 */
declare global {
  interface Window {
    process?: {
      platform: string;
    };
    __bdSocketUnloadEventAdded?: boolean;
  }
}
